import Vue from 'vue'
import dayjs from 'dayjs'
import { HELMET_TYPE } from '@/common/enum'
import i18n from '@/common/i18n'

// 日期格式化
Vue.filter('date', value => {
  var dayjsValue = dayjs(value)
  if (dayjsValue.isValid()) {
    return dayjsValue.format('YYYY-MM-DD')
  } else {
    return ''
  }
})

Vue.filter('datetimeShort', value => {
  var dayjsValue = dayjs(value)
  if (dayjsValue.isValid()) {
    return dayjsValue.format('YYYY-MM-DD HH:mm')
  } else {
    return ''
  }
})

Vue.filter('datetime', value => {
  var dayjsValue = dayjs(value)
  if (dayjsValue.isValid()) {
    return dayjsValue.format('YYYY-MM-DD HH:mm:ss')
  } else {
    return ''
  }
})
// 长度超过15字符自动加省略号
Vue.filter('ellipsis', value => {
  if (!value) return ''
  if (value.length > 15) {
    return value.slice(0, 15) + '...'
  }
  return value
})

// 长度超过5字符自动加省略号
Vue.filter('ellipsisWalkie', value => {
  if (!value) return ''
  if (value.length > 5) {
    return value.slice(0, 5) + '...'
  }
  return value
})

// 长度超过8字符自动加省略号
Vue.filter('ellipsisEight', value => {
  if (!value) return ''
  if (value.length > 8) {
    return value.slice(0, 8) + '...'
  }
  return value
})

// 取名字第一个字
Vue.filter('firstName', value => {
  if (!value) {
    return ''
  } else {
    return value.split('')[0]
  }
})

// 过滤对讲状态
Vue.filter('status', value => {
  if (!value) {
    return ''
  } else {
    switch (value) {
      case '0':
        return i18n.t('inCall')
      case '1':
        return i18n.t('onCall')
      case '2':
        return i18n.t('refuse')
      case '3':
        return i18n.t('noAnswertimeout')
      case '4':
        return i18n.t('Busy')
      case '5':
        return i18n.t('offLine')
      case '6':
        return i18n.t('hangedUp')
    }
  }
})

// 过滤对讲样式
Vue.filter('classFilter', value => {
  if (!value) {
    return ''
  } else {
    switch (value) {
      case '0':
        return 'default'
      case '1':
        return 'default'
      case '2':
        return 'refuse'
      case '3':
        return 'refuse'
      case '4':
        return 'refuse'
      case '5':
        return 'offLine'
      case '6':
        return 'refuse'
    }
  }
})

Vue.filter('systemStatus', value => {
  switch (value) {
    case i18n.t('关闭'):
      return i18n.t('关机')
    case i18n.t('无'):
      return i18n.t('关机')
    case i18n.t('开启'):
      return i18n.t('开机')
    case '':
      return ''
    default:
      return value
  }
})

/**
 * 设备在线状态过滤器
 * 0=离线，1=在线
 */
Vue.filter('onlineStatus', value => {
  return value === 1 ? i18n.t('onLine') : i18n.t('offLine')
})

/**
 * 设备类型过滤器
 */
Vue.filter('helmetType', value => {
  let label = ''
  HELMET_TYPE.forEach(type => {
    if (type.value === value) {
      label = type.label
    }
  })
  return label
})

/**
 * 四舍五入 + 保留2位小数   1.114 -> 1.11   1.115 -> 1.12
 */
Vue.filter('toFixed2', value => {
  return Math.round(value * 100) / 100
})
